import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { map, Observable } from 'rxjs';
import { BaseApiService } from './base-api.service';
@Injectable({
  providedIn: 'root',
})
export class PartneroService {
  private httpClient = inject(HttpClient);
  private oAuth = inject(OAuthService);
  private baseApiService = inject(BaseApiService);
  private baseApiUrl = inject<string>('BASE_API_URL' as any);

  url: string;

  constructor() {
    this.url = `${this.baseApiUrl}`;
  }

  singUpFromAffiliate(email: string, name: string, affiliateKey: string): Observable<any> {
    let model = {
      key: email,
      email: email,
      name: name,
      partner: {
        key: affiliateKey,
      },
    };
    return this.httpClient.post<any>(`${this.url}/proxy/partnero/affiliate`, model);
  }
  singUpFromPartner(email: string, name: string, partnerKey: string): Observable<any> {
    let model = {
      key: email,
      email: email,
      name: name,
      partner: {
        key: partnerKey,
      },
    };
    return this.httpClient.post<any>(`${this.url}/proxy/partnero/partner`, model);
  }
  singUpFromCustomer(email: string, name: string, customerKey: string): Observable<any> {
    let model = {
      id: email,
      name: name,
      email: email,
      referring_customer: {
        key: customerKey,
      },
    };
    return this.httpClient.post<any>(`${this.url}/proxy/partnero/referred`, model);
  }

  createPartneroCustomer(email: string, name: string): Observable<any> {
    let model = {
      id: email,
      name: name,
      email: email,
    };
    return this.httpClient
      .post<any>(`${this.url}/proxy/partnero/customer`, model)
      .pipe(map((response: any) => JSON.parse(response)));
  }

  getPartneroCustomer(email: string): Observable<any> {
    return this.httpClient
      .get<any>(`${this.url}/proxy/partnero/customer/` + email)
      .pipe(map((response: any) => JSON.parse(response)));
  }
}
